import { getMinimumSessionDetail, getSessionDetail, AttachmentDetail } from '@fs/zion-rootstech'
import Agreement from './Agreement'
import { MinimumDashboardCreatorDetail } from './CreatorDetail'

export const getMinDashboardSessionDetail = (includeAudiences = false) => `
  ${getMinimumSessionDetail(includeAudiences)}
  ${Agreement}
  ${AttachmentDetail}
  ${MinimumDashboardCreatorDetail}
  fragment MinDashboardSessionDetail on SessionDetail {
    ...MinimumSessionDetail
    agreements {
      ...Agreement
    }
    classSyllabus {
      ...AttachmentDetail
    }
    creators {
      ...MinimumDashboardCreatorDetail
    }
    publishSlides
    slideDeck {
      ...AttachmentDetail
    }
  }
`

export const getDashboardSessionDetail = (includeAudiences = false) => `
  ${getSessionDetail(includeAudiences)}
  ${Agreement}
  fragment DashboardSessionDetail on SessionDetail {
    ...SessionDetail
    agreements {
      ...Agreement
    }
    coSpeakers
    sessionDeliverable
  }
`
